import { render, staticRenderFns } from "./class-relevancy.vue?vue&type=template&id=28536ae4"
import script from "./class-relevancy.vue?vue&type=script&lang=js"
export * from "./class-relevancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28536ae4')) {
      api.createRecord('28536ae4', component.options)
    } else {
      api.reload('28536ae4', component.options)
    }
    module.hot.accept("./class-relevancy.vue?vue&type=template&id=28536ae4", function () {
      api.rerender('28536ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-relevancy.vue"
export default component.exports